import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { currency } from "../../common/services/common.service";
import PageLoader from "../../components/PageLoader";
import { useAppDispatch } from "../../hooks/hooks";
import { selectCurrent } from "../../redux/settings/selectors";
import { channel } from "../../redux/channel/action";
import { selectProductSummaryItems } from "../../redux/products-summary/selector";
import { selectOrdersSummaryItems } from "../../redux/orders-summary/selector";
import { products } from "../../redux/products-summary/action";
import { orders } from "../../redux/orders-summary/action";
import { selectCustomersSummaryItems } from "../../redux/customers-summary/selector";
import { customers } from "../../redux/customers-summary/action";

const AgencyHome = () => {
	const dispatch = useAppDispatch()
	const result = useSelector(selectCurrent)
	const [isLoading, setIsLoading] = useState<Boolean>(true)
const orderSummaries = useSelector(selectOrdersSummaryItems)
const productSummaries = useSelector(selectProductSummaryItems)
const customerSummaries = useSelector(selectCustomersSummaryItems)
	const fetchDashboard = (type:any) => {
		const startDate = moment().startOf(type as moment.unitOfTime.StartOf)
		  .format()
		const endDate = moment().endOf(type as moment.unitOfTime.StartOf)
		  .format()
	
		dispatch(channel.list({
			url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/organization-management/channels/list`, entity: 'channels', jsonData: {

			}
		})).then(() => {		  
		  dispatch(products.summary({url:`https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/catalog/products/summary`,entity:'productsSummary',jsonData:{
          
		  
			"Records": [
			  {
				"StartDate":startDate,
				"EndDate": endDate
			  }
			]
		  
		  }
		}))
		}).then(() => {
		dispatch(orders.summary({url:`https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dom/orders/summary`,entity:'ordersSummary',jsonData:{
          
		  
		"Records": [
		  {
			"StartDate":startDate,
			"EndDate": endDate
		  }
		]
	  
	
  }}))
	  }).then(()=>{
		dispatch(customers.summary({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/customers/summary`,entity:'customersSummary',jsonData:{
          
		  
		"Records": [
		  {
			"StartDate":startDate,
			"EndDate": endDate
		  }
		]
	  
	
  }})).then(()=>{
	setIsLoading(false)
  })
	  })
	  }


	useEffect(() => {
		
	}, []);
	useEffect(
		() => {
			
			fetchDashboard('day')
		},
		[isLoading]
	  )
	
	return (
		<>
	
{isLoading ? <PageLoader /> :
	<div className={`flex flex-col items-center p-10 bg-blue-100 `}>
			{/* <div className="flex items-start w-full">
				<nav className="text-sm font-semibold my-3" aria-label="Breadcrumb">
					<ol className="list-none p-0 inline-flex">
						<li className="flex items-center text-blue-500">
							<a href="#" className="text-gray-700"><FormattedMessage id="app.title" /></a>
							<svg className="fill-current w-3 h-3 mx-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" /></svg>
						</li>
						<li className="flex items-center">
							<a href="#" className="text-gray-600"><FormattedMessage id="app.tagline" /></a>
						</li>
					</ol>
				</nav>
			</div> */}
			{/* <div className="flex justify-between items-center mb-6 w-full">
				<p className="text-2xl font-semibold mb-2 mb-0"><FormattedMessage id="app.heading" /></p>
			</div> */}
			<div className=" flex justify-center items-center ">
<button
 type='button'
 onClick={() => { fetchDashboard('day') }}
 className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
>
	Today
</button>
<button
 type='button'
 onClick={() => { fetchDashboard('Week') }}
 className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
>
	This Week 
</button>
<button
 type='button'
 onClick={() => { fetchDashboard('Month') }}
 className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
>
	This Month
</button>
<button
 type='button'
 onClick={() => { fetchDashboard('year'); }}
 className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
>
	This Year
</button>
			</div>
			<div className="w-full flex items-center flex-col  lg:flex-row p-1">
				<div className="flex flex-row items-center bg-indigo-200 justify-center h-36 w-full m-4 ">
					<svg className="bg-indigo-200 w-1/3 h-12 mx-2 fill-current " 
					fill="#000000" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M136.948 908.811c5.657 0 10.24-4.583 10.24-10.24V610.755c0-5.657-4.583-10.24-10.24-10.24h-81.92a10.238 10.238 0 00-10.24 10.24v287.816c0 5.657 4.583 10.24 10.24 10.24h81.92zm0 40.96h-81.92c-28.278 0-51.2-22.922-51.2-51.2V610.755c0-28.278 22.922-51.2 51.2-51.2h81.92c28.278 0 51.2 22.922 51.2 51.2v287.816c0 28.278-22.922 51.2-51.2 51.2zm278.414-40.96c5.657 0 10.24-4.583 10.24-10.24V551.322c0-5.657-4.583-10.24-10.24-10.24h-81.92a10.238 10.238 0 00-10.24 10.24v347.249c0 5.657 4.583 10.24 10.24 10.24h81.92zm0 40.96h-81.92c-28.278 0-51.2-22.922-51.2-51.2V551.322c0-28.278 22.922-51.2 51.2-51.2h81.92c28.278 0 51.2 22.922 51.2 51.2v347.249c0 28.278-22.922 51.2-51.2 51.2zm278.414-40.342c5.657 0 10.24-4.583 10.24-10.24V492.497c0-5.651-4.588-10.24-10.24-10.24h-81.92c-5.652 0-10.24 4.589-10.24 10.24v406.692c0 5.657 4.583 10.24 10.24 10.24h81.92zm0 40.96h-81.92c-28.278 0-51.2-22.922-51.2-51.2V492.497c0-28.271 22.924-51.2 51.2-51.2h81.92c28.276 0 51.2 22.929 51.2 51.2v406.692c0 28.278-22.922 51.2-51.2 51.2zm278.414-40.958c5.657 0 10.24-4.583 10.24-10.24V441.299c0-5.657-4.583-10.24-10.24-10.24h-81.92a10.238 10.238 0 00-10.24 10.24v457.892c0 5.657 4.583 10.24 10.24 10.24h81.92zm0 40.96h-81.92c-28.278 0-51.2-22.922-51.2-51.2V441.299c0-28.278 22.922-51.2 51.2-51.2h81.92c28.278 0 51.2 22.922 51.2 51.2v457.892c0 28.278-22.922 51.2-51.2 51.2zm-6.205-841.902C677.379 271.088 355.268 367.011 19.245 387.336c-11.29.683-19.889 10.389-19.206 21.679s10.389 19.889 21.679 19.206c342.256-20.702 670.39-118.419 964.372-284.046 9.854-5.552 13.342-18.041 7.79-27.896s-18.041-13.342-27.896-7.79z"></path><path d="M901.21 112.64l102.39.154c11.311.017 20.494-9.138 20.511-20.449s-9.138-20.494-20.449-20.511l-102.39-.154c-11.311-.017-20.494 9.138-20.511 20.449s9.138 20.494 20.449 20.511z"></path><path d="M983.151 92.251l-.307 101.827c-.034 11.311 9.107 20.508 20.418 20.542s20.508-9.107 20.542-20.418l.307-101.827c.034-11.311-9.107-20.508-20.418-20.542s-20.508 9.107-20.542 20.418z"></path></g></svg>
					<div className="h-36 w-2/3 space-y-3 px-4  flex flex-col bg-white  items-start justify-center ">
						<div className="font-semibold text-3xl">{currency(orderSummaries ? orderSummaries?.result?.items?.TotalRevenue : 0)} </div>
						<div>Revenue</div>
					</div>
				</div>
				<div className="flex flex-row items-center bg-green-200 justify-center h-36 w-full m-4 ">
					<svg className="bg-green-200 w-1/3 h-12 mx-2  fill-current" viewBox="0 0 20 20" version="1.1" ><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>shopping_cart [#1135]</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"> <g id="Dribbble-Light-Preview" transform="translate(-220.000000, -3119.000000)" fill="#000000"> <g id="icons" transform="translate(56.000000, 160.000000)"> <path d="M180.846448,2977 L167.153448,2977 C166.544448,2977 166.077448,2976.461 166.163448,2975.859 L167.306448,2967.859 C167.376448,2967.366 167.798448,2967 168.296448,2967 L168.999448,2967 L168.999448,2969 C168.999448,2969.552 169.447448,2970 169.999448,2970 C170.552448,2970 170.999448,2969.552 170.999448,2969 L170.999448,2967 L176.999448,2967 L176.999448,2969 C176.999448,2969.552 177.447448,2970 177.999448,2970 C178.552448,2970 178.999448,2969.552 178.999448,2969 L178.999448,2967 L179.703448,2967 C180.201448,2967 180.623448,2967.366 180.693448,2967.859 L181.836448,2975.859 C181.922448,2976.461 181.455448,2977 180.846448,2977 L180.846448,2977 Z M170.999448,2964 C170.999448,2962.346 172.345448,2961 173.999448,2961 C175.654448,2961 176.999448,2962 176.999448,2964 L176.999448,2965 L170.999448,2965 L170.999448,2964 Z M183.979448,2976.717 L182.550448,2966.717 C182.410448,2965.732 181.566448,2965 180.570448,2965 L178.999448,2965 L178.999448,2964 C178.999448,2961 176.756448,2959 173.999448,2959 C171.243448,2959 168.999448,2961.243 168.999448,2964 L168.999448,2965 L167.734448,2965 C166.739448,2965 165.589448,2965.732 165.448448,2966.717 L164.020448,2976.717 C163.848448,2977.922 164.783448,2979 166.000448,2979 L181.999448,2979 C183.216448,2979 184.151448,2977.922 183.979448,2976.717 L183.979448,2976.717 Z" id="shopping_cart-[#1135]"> </path> </g> </g> </g> </g></svg>
					<div className="h-36 w-2/3 space-y-3 px-4  flex flex-col bg-white  items-start px-2 justify-center">
						<p className="font-semibold text-3xl">{currency(orderSummaries ? orderSummaries?.result?.items?.TotalNoOfOrders : 0)} </p>
						<p>Orders</p>
					</div>
				</div>
				<div className="flex flex-row items-center bg-orange-200 justify-center h-36 w-full m-4">
					<svg className="bg-orange-200 w-1/3 h-12 mx-2  fill-current " 
					viewBox="0 0 16 16" version="1.1" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <rect width="16" height="16" id="icon-bound" fill="none"></rect> <path d="M16,12.5C16,11.837 15.737,11.201 15.268,10.732C14.799,10.263 14.163,10 13.5,10C11.447,10 8.553,10 6.5,10C5.837,10 5.201,10.263 4.732,10.732C4.263,11.201 4,11.837 4,12.5C4,14.147 4,15 4,15L16,15C16,15 16,14.147 16,12.5ZM3,13L0,13C0,13 0,12.147 0,10.5C0,9.837 0.263,9.201 0.732,8.732C1.201,8.263 1.837,8 2.5,8L6.536,8C6.754,8.376 7.031,8.714 7.355,9L6.5,9C4.567,9 3,10.567 3,12.5L3,13ZM10,3C11.656,3 13,4.344 13,6C13,7.656 11.656,9 10,9C8.344,9 7,7.656 7,6C7,4.344 8.344,3 10,3ZM6.126,6.997C6.084,6.999 6.042,7 6,7C4.344,7 3,5.656 3,4C3,2.344 4.344,1 6,1C7.026,1 7.932,1.516 8.473,2.302C7.022,2.903 6,4.333 6,6C6,6.344 6.044,6.679 6.126,6.997Z"></path> </g></svg>
					<div className="h-36 w-2/3 space-y-3 px-4 flex flex-col bg-white  items-start px-2 justify-center">
						<p className="font-semibold text-3xl">{currency(orderSummaries ? orderSummaries?.result?.items?.TotalNoOfCustomers : 0)} </p>
						<p>Customers</p>
					</div>
				</div>
				{/* <div className="flex flex-row items-center bg-yellow-200 justify-center h-36 w-full m-4 ">
					<svg className="bg-yellow-200 w-1/3 h-12 mx-2 fill-current" viewBox="0 0 20 20">
						<path d="M17.431,2.156h-3.715c-0.228,0-0.413,0.186-0.413,0.413v6.973h-2.89V6.687c0-0.229-0.186-0.413-0.413-0.413H6.285c-0.228,0-0.413,0.184-0.413,0.413v6.388H2.569c-0.227,0-0.413,0.187-0.413,0.413v3.942c0,0.228,0.186,0.413,0.413,0.413h14.862c0.228,0,0.413-0.186,0.413-0.413V2.569C17.844,2.342,17.658,2.156,17.431,2.156 M5.872,17.019h-2.89v-3.117h2.89V17.019zM9.587,17.019h-2.89V7.1h2.89V17.019z M13.303,17.019h-2.89v-6.651h2.89V17.019z M17.019,17.019h-2.891V2.982h2.891V17.019z"></path>
					</svg>
					<div className="h-36 w-2/3 space-y-3 px-4  flex flex-col bg-white  items-start justify-center">
						<p className="font-semibold text-3xl">{currency(1653)} </p>
						<p><FormattedMessage id="app.tag4" /></p>
					</div>
				</div> */}
			</div>
			<div className="w-full flex items-center flex-col  lg:flex-row p-1">
				<div className="w-full flex flex-col px-3">
					<div className="text-xl font-semibold mb-4"> Sales Report</div>
					<div className="w-full bg-white  grid grid-cols-3 gap-4 rounded-lg p-4">
					{orderSummaries?.result?.items?.channelOrderSummaries.map((channel:any)=>(
					<div className=" border-2 items-center bg-green-500 flex flex-row justify-center h-28 w-full m-2  ">
					
					<svg className="w-1/3 h-12 mx-2 " viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>shopping-cart-filled</title> <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"> <g id="icon" fill="#fafafa" transform="translate(42.666667, 85.333333)"> <path d="M7.10542736e-15,-1.42108547e-14 L70.3622093,-1.42108547e-14 L89.7493333,85.3333333 L378.389061,85.3333333 L337.246204,277.333333 L89.6377907,277.333333 L36.288,42.6666667 L7.10542736e-15,42.6666667 L7.10542736e-15,-1.42108547e-14 Z M138.666667,384 C156.339779,384 170.666667,369.673112 170.666667,352 C170.666667,334.326888 156.339779,320 138.666667,320 C120.993555,320 106.666667,334.326888 106.666667,352 C106.666667,369.673112 120.993555,384 138.666667,384 Z M288,384 C305.673112,384 320,369.673112 320,352 C320,334.326888 305.673112,320 288,320 C270.326888,320 256,334.326888 256,352 C256,369.673112 270.326888,384 288,384 Z" id="Combined-Shape"> </path> </g> </g> </g></svg>
					<div className="h-28 w-2/3 space-y-1 px-2  flex flex-col bg-white  items-start border-2 justify-center">
					<p className="font-semibold text-2xl">{channel?.ChannelName}</p>
						<p >Revenue : {currency(channel?.Revenue)} </p>
						<p>Orders : {channel?.NoOfOrders} </p>
					</div>
					</div>
					)
				)
				}
					
					
					</div>
				</div>
				
				
			</div>
			<div className="w-full flex items-center flex-col  lg:flex-row p-1">
			<div className="w-full p-3 my-3">
					<div className="text-xl font-semibold mb-4">Product Report</div>
					<div className="w-full bg-white grid grid-cols-2 gap-4 rounded-lg p-4">
					<div className="  items-center flex flex-row justify-center h-28 w-full m-2  ">
					<div className=" w-full h-28 space-y-4 px-2  flex flex-col bg-green-300 items-center border-green-300 border-2 rounded-2xl justify-center">
					<p className="font-semibold text-xl text-white">Top Selling Products</p>
						<p className="font-bold text-2xl text-white"> {productSummaries ? productSummaries?.result?.items?.TopSellingProducts : 0} </p>
					</div>
					</div>
					<div className="  items-center flex flex-row justify-center h-28 w-full m-2  ">
					<div className=" w-full h-28 space-y-4 px-2  flex flex-col bg-indigo-300 border-indigo-300 items-center border-2 rounded-2xl justify-center">
					<p className="font-semibold text-xl text-white">Total Products</p>
						<p className="font-bold text-2xl text-white"> {productSummaries ? productSummaries?.result?.items?.TotalNoOfProducts : 0} </p>
					</div>
					</div>
					<div className="  items-center flex flex-row justify-center h-28 w-full m-2  ">
					<div className=" w-full h-28 space-y-4 px-2  flex flex-col bg-orange-300 border-orange-300 items-center border-2 rounded-2xl justify-center">
					<p className="font-semibold text-xl text-white">Out Of Stock Products</p>
						<p className="font-bold text-2xl text-white"> {productSummaries ? productSummaries?.result?.items?.OutOfStockProducts : 0} </p>
					</div>
					</div>
					<div className="  items-center flex flex-row justify-center h-28 w-full m-2  ">
					<div className=" w-full h-28 space-y-4 px-2  flex flex-col bg-yellow-300 border-yellow-300 items-center border-2 rounded-2xl justify-center">
					<p className="font-semibold text-xl text-white">Low Stock Products</p>
						<p className="font-bold text-2xl text-white"> {productSummaries ? productSummaries?.result?.items?.LowStockProducts : 0} </p>
					</div>
					</div>
					<div className="  items-center flex flex-row justify-center h-28 w-full m-2  ">
					{/* <div className=" w-full h-28 space-y-4 px-2  flex flex-col bg-yellow-300 border-yellow-300 items-center border-2 rounded-2xl justify-center">
					<p className="font-semibold text-xl text-white">Low Stock Products</p>
						<p className="font-bold text-2xl text-white"> {productSummaries ? productSummaries?.result?.items?.LowStockProducts : 0} </p>
					</div> */}
					</div>
					<div className="  items-center flex flex-row justify-center h-28 w-full m-2  ">
					{/* <div className=" w-full h-28 space-y-4 px-2  flex flex-col bg-yellow-300 border-yellow-300 items-center border-2 rounded-2xl justify-center">
					<p className="font-semibold text-xl text-white">Low Stock Products</p>
						<p className="font-bold text-2xl text-white"> {productSummaries ? productSummaries?.result?.items?.LowStockProducts : 0} </p>
					</div> */}
					</div>
					</div>
				</div>
				<div className="w-full flex flex-col px-3">
					<div className="text-xl font-semibold mb-4"> Customers Report</div>
					<div className="w-full bg-white grid grid-cols-2 gap-4 rounded-lg p-4">
					<div className="  items-center flex flex-row justify-center h-28 w-full m-2  ">
					<div className=" w-full h-28 space-y-4 px-2  flex flex-col bg-orange-300 items-center border-orange-300 border-2 rounded-2xl justify-center">
					<p className="font-semibold text-xl text-white">Store Customers</p>
						<p className="font-bold text-2xl text-white"> {customerSummaries ? customerSummaries?.result?.items?.TotalNoOfStoreCustomers : 0} </p>
					</div>
					</div>
					<div className="  items-center flex flex-row justify-center h-28 w-full m-2  ">
					<div className=" w-full h-28 space-y-4 px-2  flex flex-col bg-green-300 border-green-300 items-center border-2 rounded-2xl justify-center">
					<p className="font-semibold text-xl text-white">Online Customers</p>
						<p className="font-bold text-2xl text-white"> {customerSummaries ? customerSummaries?.result?.items?.TotalNoOfOnlineCustomers : 0} </p>
					</div>
					</div>
					<div className="  items-center flex flex-row justify-center h-28 w-full m-2  ">
					<div className=" w-full h-28 space-y-4 px-2  flex flex-col bg-pink-300 border-pink-300 items-center border-2 rounded-2xl justify-center">
					<p className="font-semibold text-xl text-white">Registred Customers</p>
						<p className="font-bold text-2xl text-white"> {customerSummaries ? customerSummaries?.result?.items?.TotalNoOfNewlyRegistredCustomers : 0} </p>
					</div>
					</div>
					<div className="  items-center flex flex-row justify-center h-28 w-full m-2  ">
					<div className=" w-full h-28 space-y-4 px-2  flex flex-col bg-yellow-300 border-yellow-300 items-center border-2 rounded-2xl justify-center">
					<p className="font-semibold text-xl text-white">Guest Visited Websites</p>
						<p className="font-bold text-2xl text-white"> {customerSummaries ? customerSummaries?.result?.items?.TotalNoOfGuestVisitedWebsites : 0} </p>
					</div>
					</div>
					<div className="  items-center flex flex-row justify-center h-28 w-full m-2  ">
					<div className=" w-full h-28 space-y-4 px-2  flex flex-col bg-purple-300 border-purple-300 items-center border-2 rounded-2xl justify-center">
					<p className="font-semibold text-xl text-white">Abondon Checkouts</p>
						<p className="font-bold text-2xl text-white"> {customerSummaries ? customerSummaries?.result?.items?.TotalNoOfAbondonCheckouts : 0} </p>
					</div>
					</div>
					<div className="  items-center flex flex-row justify-center h-28 w-full m-2  ">
					<div className=" w-full h-28 space-y-4 px-2  flex flex-col bg-indigo-300 border-indigo-300 items-center border-2 rounded-2xl justify-center">
					<p className="font-semibold text-xl text-white">Add To Cart</p>
						<p className="font-bold text-2xl text-white"> {customerSummaries ? customerSummaries?.result?.items?.TotalNoOfUnClearedShoppingCarts : 0} </p>
					</div>
					</div>
					</div>
				</div>
				</div>
			<div className="w-full flex items-center flex-col  lg:flex-row p-1">
		
				<div className="w-full p-3 my-3">
					<div className="text-xl font-semibold mb-4">Store Report</div>
					<div className="w-full bg-white grid grid-cols-3 gap-4 rounded-lg p-4">
					{orderSummaries?.result?.items?.storeOrderSummaries.map((store:any)=>(
					<div className=" border-2 items-center bg-blue-600 flex flex-row justify-center h-28 w-full m-2  ">
					
					<svg className="w-1/3 h-12 mx-2 "
					fill="#ffffff" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 297 297" stroke="#ffffff"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <g> <path d="M287.262,275.332h-0.487V11.929c0-5.378-4.36-9.738-9.738-9.738H19.962c-5.378,0-9.738,4.36-9.738,9.738v263.405H9.738 c-5.378,0-9.738,4.36-9.738,9.738s4.36,9.738,9.738,9.738h277.524v-0.001c5.378,0,9.738-4.36,9.738-9.738 S292.64,275.332,287.262,275.332z M222.507,21.666h12.659v54.532c0,3.49-2.84,6.33-6.33,6.33s-6.329-2.84-6.329-6.33V21.666z M190.372,21.666h12.659v54.532c0,3.49-2.84,6.33-6.329,6.33c-3.49,0-6.33-2.84-6.33-6.33V21.666z M158.237,21.666h12.659v54.532 h0.001c0,3.49-2.84,6.33-6.33,6.33s-6.33-2.84-6.33-6.33V21.666z M126.102,21.666h12.659v54.532h0.001 c0,3.49-2.84,6.33-6.33,6.33s-6.33-2.84-6.33-6.33V21.666z M93.968,21.666h12.659v54.532h0.001c0,3.49-2.84,6.33-6.33,6.33 c-3.49,0-6.33-2.84-6.33-6.33V21.666z M61.833,21.666h12.659v54.532h0.001c0,3.49-2.84,6.33-6.33,6.33 c-3.49,0-6.33-2.84-6.33-6.33V21.666z M68.164,102.002c6.071,0,11.655-2.113,16.067-5.634c4.412,3.522,9.996,5.634,16.067,5.634 c6.071,0,11.655-2.113,16.067-5.634c4.412,3.522,9.996,5.634,16.067,5.634s11.655-2.113,16.067-5.634 c4.412,3.522,9.996,5.634,16.067,5.634c6.071,0,11.655-2.113,16.067-5.634c4.412,3.522,9.996,5.634,16.067,5.634 s11.655-2.113,16.067-5.634c4.412,3.522,9.996,5.634,16.067,5.634c6.071,0,11.655-2.113,16.067-5.634 c4.412,3.522,9.996,5.634,16.067,5.634c2.183,0,4.303-0.275,6.329-0.788v13.447H29.7v-13.447c2.026,0.513,4.146,0.788,6.33,0.788 c6.071,0,11.655-2.113,16.067-5.634C56.509,99.89,62.093,102.002,68.164,102.002z M29.699,21.666H29.7h12.659v54.531 c0,3.49-2.84,6.33-6.33,6.33s-6.33-2.84-6.33-6.33V21.666z M42.359,275.333H29.7v-28.726h12.659V275.333z M42.359,227.131H29.7 v-92.995h12.659V227.131z M122.695,275.333H61.834v-78.875h60.861V275.333z M122.695,180.877H61.834v-46.741h60.861V180.877z M267.3,275.333H142.17v-28.726H267.3V275.333z M267.3,227.131H142.17v-92.995H267.3V227.131z M267.3,76.198 c0,3.49-2.84,6.33-6.329,6.33s-6.329-2.84-6.329-6.33V21.666H267.3V76.198z"></path> <path d="M72.543,228.591c2.054,0,4.061-0.828,5.512-2.278c1.45-1.451,2.278-3.458,2.278-5.512c0-2.055-0.828-4.061-2.278-5.512 c-1.451-1.45-3.458-2.278-5.512-2.278c-2.045,0-4.061,0.827-5.502,2.278c-1.451,1.451-2.288,3.457-2.288,5.512 c0,2.054,0.837,4.061,2.288,5.512C68.492,227.763,70.498,228.591,72.543,228.591z"></path> </g> </g> </g> </g></svg>
					<div className="h-28 w-2/3 space-y-1 px-2  flex flex-col bg-white  items-start border-2 justify-center">
					<p className="font-semibold text-2xl">{store?.StoreName}</p>
						<p >Revenue : {currency(store?.Revenue)} </p>
						<p>Orders : {store?.NoOfOrders} </p>
					</div>
					</div>
					)
				)
				}
					
					
					</div>
				</div>
				
			</div>
			{/* <div className="w-full px-3">
				<div className="text-xl font-semibold mb-4">Recent Transactions</div>
				<div className="w-full bg-white border rounded-lg p-4">
					<div className="w-full bg-gray-100 border rounded-lg flex justify-between items-center px-4 py-2 mb-4">
						<div>
							<p className="font-semibold text-xl">Trent Murphy</p>
							<p>Product 1</p>
						</div>
						<span className="text-green-500 font-semibold text-lg">$25.00</span>
					</div>
					<div className="w-full bg-gray-100 border rounded-lg flex justify-between items-center px-4 py-2 mb-4">
						<div>
							<p className="font-semibold text-xl">Joseph Brent</p>
							<p>Product 34</p>
						</div>
						<span className="text-red-500 font-semibold text-lg">$74.99</span>
					</div>
					<div className="w-full bg-gray-100 border rounded-lg flex justify-between items-center px-4 py-2 mb-4">
						<div>
							<p className="font-semibold text-xl">Jacob Bator</p>
							<p>Product 23</p>
						</div>
						<span className="text-green-500 font-semibold text-lg">$14.95</span>
					</div>
					<div className="w-full bg-gray-100 border rounded-lg flex justify-between items-center px-4 py-2">
						<div>
							<p className="font-semibold text-xl">Alex Mason</p>
							<p>Product 66</p>
						</div>
						<span className="text-green-500 font-semibold text-lg">$44.99</span>
					</div>
				</div>
			</div> */}
		</div>}
	
		</>
		
	);
};

export default AgencyHome;

